import useCompanyStatus from "../superdashboard/hooks/useCompanyStatus";
import { COMPANY_STATUS } from "@demandproai/shared";
import { useMemo, useState } from "react";
import CardHeader from "./common/CardHeader";
import CompaniesModal from "../components/CompaniesModal";
import XButton from "../../../components/common/XButton";
import { useCompanyFilterContext } from "./context/CompanyFilterContext";
import { COMPANY_MODAL_KEYS } from "../../../utils/enum";
import { statCardClasses } from "../../../components/common/dashboardClasses";

const StatCard = ({ label, value, onClick }) => (
  <div className="bg-surface-alt h-[calc(var(--spacing)*32.5)] p-4 rounded cursor-pointer" onClick={onClick}>
    <div className="flex justify-between items-center mb-4">
      <span className="text-subtle text-sm">{label}</span>
      {onClick && (<XButton variant="close" className="p-0! text-sm"><i className="fas fa-arrow-right"></i></XButton>)}
    </div>
    <h4 className="mb-0 font-bold">{value}</h4>
  </div>
);

const CombinedStatCard = ({ stats }) => (
  <div className="bg-surface-alt h-[calc(var(--spacing)*32.5)] p-4 rounded">
    <div className="flex justify-between items-center">
      {stats.map((stat, index) => (
        <div key={index} className={index > 0 ? "ml-6" : ""}>
          <span className="text-subtle block mb-4 text-sm">{stat.label}</span>
          <h4 className="mb-0 font-bold">{stat.value}</h4>
        </div>
      ))}
    </div>
  </div>
);

const CompanyYTD = () => {
  const { filterParams } = useCompanyFilterContext();
  const statuses = useMemo(() => [COMPANY_STATUS.SUBSCRIBED, COMPANY_STATUS.CANCELED], []);

  const { companiesYTDStats, companiesData, loading, error } = useCompanyStatus(
    filterParams.selectedRange,
    statuses
  );

  const [selectedStatus, setSelectedStatus] = useState(null);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className={statCardClasses}>
      <CardHeader title="Customer Churn" />
      <div className="row g-3">
        <div className="col-12 col-md-6">
          <StatCard
            label="Signed Up"
            value={companiesYTDStats.subscribedCount}
            onClick={() =>
              setSelectedStatus(COMPANY_MODAL_KEYS.SIGNED_UP_YTD)
            }
          />
        </div>

        <div className="col-12 col-md-6">
          <StatCard
            label="Canceled"
            value={companiesYTDStats.canceledCount}
            onClick={() =>
              setSelectedStatus(COMPANY_MODAL_KEYS.CANCELED_YTD)
            }
          />
        </div>

        <div className="col-12">
          <CombinedStatCard
            stats={[
              { label: "Net Change", value: companiesYTDStats.netChange },
              { label: "Churn Rate", value: companiesYTDStats.churnRate }
            ]}
          />
        </div>
        <CompaniesModal
          open={!!selectedStatus}
          configKey={selectedStatus}
          dashboardData={{
            companiesYTDData: companiesData
          }}
          isLoading={loading}
          onClose={()=> setSelectedStatus(null)}
        />
      </div>
    </div>
  );
};

export default CompanyYTD;